import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { hasBackofficeAccess } from '@/lib/auth-access'
import { useAuthStore } from '@/store/auth.store'

export function ProtectedRoute() {
  const token = useAuthStore((s) => s.token)
  const user = useAuthStore((s) => s.user)
  const location = useLocation()

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  if (!hasBackofficeAccess(user)) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return <Outlet />
}
